import React from "react";
import { Box } from "@material-ui/core";
import { ElectricityIcon, GasIcon, GenericUtilityIcon } from "../../../icons";

export const MeterPointIcon: React.FC<{ type: string }> = ({ type }) => (
  <Box display="inline-flex" data-testid="MeterPoint__Icon">
    {type === "MPAN" ? (
      <ElectricityIcon />
    ) : type === "MPRN" ? (
      <GasIcon />
    ) : (
      <GenericUtilityIcon />
    )}
  </Box>
);
